var exports = {
  "K2": "PricingGrid.module__gridWrapper___UWE5NF",
  "Vg": "PricingGrid.module__grid___UWE5NF",
  "mS": "PricingGrid.module__gridTwoColumns___UWE5NF" + " " + "PricingGrid.module__grid___UWE5NF",
};

module.exports = exports;
